/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Subscribe
 *
 * 1 = SignedNotCompleted
 *
 * 2 = Cancelled
 */
export enum ServicePlanDetailsStatus {
  Subscribe = 0,
  SignedNotCompleted = 1,
  Cancelled = 2,
}
